// removed by extract-text-webpack-plugin
module.exports = {"content":"Error_content_1G3ob","title":"Error_title_V_2oF","text":"Error_text_1d2bj"};